import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

@Injectable()
export class CDResponseInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          //check if body has a property named data that's an array
          if (event.body && event.body.data && Array.isArray(event.body.data) && event.body.data.length) {
            const hascontentdistribution = event.body.data.every(item => item.hasOwnProperty('contentdistribution'));
            //check if the objects of the array contain a property named contentdistribution
            if (hascontentdistribution) {
              event = event.clone({
                body: this.normalizeContentDistribution(event.body),
              });
            }
          }
        }
        return event;
      })
    );
  }

  private normalizeContentDistribution(body: any): any {
    body.data.forEach((item: any) => {
      if (item.contentdistribution) {
        item.contentDistributionData = item.contentdistribution;
        delete item.contentdistribution;
      }
    });
    return body;
  }
}
